import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import DeleteModal from "../../components/Common/DeleteModal";
import Notification from "../../components/Common/Notification";

import moment from "moment";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomDateRangePicker from "../../components/Form/CustomDateRangePicker";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import Helpers from "../../helpers/helpers";
import { exportCategorySalesReport, getCategorySalesReport, resetReportAttachmentState } from "../../store/report/actions";
import "./report.css";

const SalesByCategory = ({ categorySalesListing, categorySalesDocument, userPermission }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [platformFilter, setPlatformFilter] = useState("");
    const [categoryFilter, setCategoryFilter] = useState("");
    const [sort_by, setSortBy] = useState('id');
    const [dateModalOpen, setDateModalOpen] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [dateRange, setDateRange] = useState([null, null]);
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [sort, setSorted] = useState("asc")
    const [exportable, setExportable] = useState(false);
    const [viewable, setViewable] = useState(false);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("export-reporting") && setExportable(true);
            userPermission?.includes("view-reporting") && setViewable(true);
            !userPermission?.includes("view-reporting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        let payload = {
            created_date_from: startDate || "",
            created_date_to: endDate || "",
            sort: sort_by,
            sort_order: sort,
            page: page,
            length: length,
            // product_type: filterObject?.productType == 0 ? "" : filterObject?.productType,
            sales_platform: platformFilter == 0 ? "" : platformFilter,
        }
        dispatch(getCategorySalesReport(payload))
    }, [endDate, platformFilter, sort, sort_by, startDate, length, page]);

    const [content, setContent] = useState({
        open: false,
        title: "",
        msg: "",
        buttonTitle: "",
        action: "",
        id: "",
    })

    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const platformList = [
        { value: "0", label: "All platforms" },
        { value: "aspeed", label: "Aventrix" },
        { value: "ariba", label: "Ariba" },
    ]

    const getLengthPage = (page, length) => {
        setPage(page)
        setLength(length)
    }

    const handleSetDateRange = (e) => {
        setPage("1");
        if (e) {
            setDateRange(e);
            setStartDate(moment(e[0]).format('YYYY-MM-DD'));
            setEndDate(moment(e[1]).format('YYYY-MM-DD'));
        } else {
            setDateRange(null);
            setStartDate(null);
            setEndDate(null);
        }
    }

    const handleExport = () => {
        let filter = {
            created_date_from: startDate,
            created_date_to: endDate,
            // product_type: filterObject?.productType == 0 ? "" : filterObject?.productType,
            sales_platform: platformFilter == 0 ? "" : platformFilter,
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all') {
                delete filter[key];
            }
        });
        setLoading(true);
        if (Object.keys(filter).length === 0) {
            dispatch(exportCategorySalesReport({
                sort_by: sort_by, sort_order: sort,
            }));
        } else {
            dispatch(exportCategorySalesReport({
                filter: filter, sort_by: sort_by, sort_order: sort,
            }));
        }

    }

    const resetFilter = () => {
        setPage("1");
        setDateRange([]);
        setStartDate(null);
        setEndDate(null);
        setPlatformFilter('');
        setCategoryFilter('');
    }

    useEffect(() => {
        if (categorySalesDocument?.code === "success") {
            setLoading(false)
            Helpers.handleDownloadExcelFile(categorySalesDocument?.excel_base64, 'sales_by_category_listing');
            dispatch(resetReportAttachmentState());
        }

    }, [categorySalesDocument]);

    const header = [
        {
            Header: "Category",
            columnID: "category_name",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div style={{ paddingRight: "5px" }}>{cellProps?.category_name || '-'}</div>
                    </React.Fragment>
                )
            },
            minWidth: 150,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Total units sold",
            columnID: "total_units_sold",
            accessor: (cellProps) => {
                return (
                    <div>{cellProps?.total_units_sold || '0'}</div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Total sales(S$)",
            columnID: "total_orders",
            accessor: (cellProps) => {
                return (
                    <div>{cellProps?.total_sales || '0.00'}</div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Average order value  (S$)",
            columnID: "average_order_value",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div>{cellProps?.average_order_value || '0.00'}</div>
                    </React.Fragment>
                )
            },
            minWidth: 150,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Top selling products",
            columnID: "top_selling_product_name",
            accessor: (cellProps) => {
                return (
                    <div>{cellProps?.top_selling_product_name || '-'}</div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
    ]

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item lg={10} md={10} sm={12} spacing={1} className="d-flex align-items-center">
                    <Grid item lg={3.5} md={5} xs={12}>
                        <CustomDateRangePicker
                            open={() => setDateModalOpen(true)}
                            close={() => setDateModalOpen(false)}
                            isOpen={dateModalOpen}
                            startDate={(startDate && moment(startDate).format('DD MMM YYYY')) || 'dd/mm/yyyy'}
                            endDate={(endDate && moment(endDate).format("DD MMM YYYY")) || 'dd/mm/yyyy'}
                            handleSetDateRange={handleSetDateRange}
                            value={dateRange}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomSelect2
                            values={platformFilter || "0"}
                            onChange={(e) => { setPage("1"); setPlatformFilter(e) }}
                            data={platformList}
                            placeholder={"Platform"}
                        />
                    </Grid>
                    <Grid item lg={5.5} md={4} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                {exportable && <Grid item lg={2} md={2} sm={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }} alignItems={'center'}>
                    <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />
                </Grid>}
            </Grid>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content textColor" style={{ minHeight: 850 }}>
                <LoadingDialog open={loading} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <DeleteModal setContent={setContent} content={content} />
                    <div className="header mb-2">Sales by Category</div>
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={categorySalesListing?.data?.data || []}
                        getLengthPage={getLengthPage}
                        pageSize={length}
                        totalPage={categorySalesListing?.data?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={categorySalesListing?.data?.last_page || 1}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

function mapStateToProps({ Report, Login }) {
    return {
        categorySalesListing: Report.categorySalesListing,
        categorySalesDocument: Report.categorySalesDocument,
        userPermission: Login.permissionArry,
    };
}

export default connect(mapStateToProps)(SalesByCategory);
